module.exports = __webpack_public_path__ + "media/icons/question-mark-188e718b.png";